import { __, always, concat, identity, join, lensIndex, pipe, unapply, view } from 'ramda';

export const createUrl = (...args: Array<string | number>) =>
  pipe(unapply(identity), view(lensIndex(0)), join('/'), concat(__, '/'))(args);

export const createQuery = (...args: Array<string | number>) => always(createUrl(...args));
